<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">3</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3>{{model.Step3bTitle}}</h3>
                <p class="qualifier-tool-subheader">{{model.Step3bSubTitle}}</p>
            </div>
        </div>
        <div class="row d-flex justify-content-center qualifier-tool-footer">
            <a class="qualifier-tool-btn" :href="model.Step3PaceOverviewUrl.replace('~', '..')">{{model.Step3PaceOverviewTitle}}</a>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
			}
		},
		computed: mapState({
		}),
		components: {
		},
		mounted: function () {
            this.clearSubmissionData();
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step3B'});    
            }
		},
		methods: {
            ...mapMutations('WebQualifierTool', { clearSubmissionData: 'clearSubmissionData' }),
        },
    }
</script>
